import Vue from 'vue'
import Vuex from 'vuex'
import * as firebase from '../firebase'
import router from '../router/index'

Vue.use(Vuex)


firebase.tasksCollection.orderBy("createdOn", "desc").onSnapshot(snapshot => {
  let tasksArray = []

  snapshot.forEach(doc => {
    let task = doc.data()
    task.id = doc.id
    tasksArray.push(task)
  })

  store.commit('setTasks', tasksArray)
})

const store = new Vuex.Store({
  state: {
    userProfile: {},
    tasks: []
  },
  mutations: {
    setUserProfile(state, val) {
      state.userProfile = val
    },
    setPerformingRequest(state, val) {
      state.performingRequest = val
    },
    setTasks(state, val) {
      state.tasks = val
    }
  },


  actions: {
    async login({ dispatch }, form) {
      //logowanko
      const { user } = await firebase.auth.signInWithEmailAndPassword(form.email, form.password)
      //akcja przypięcia uzytkownika i ustawnienie stanu
      dispatch('fetchUserProfile', user)
    },
    async signup({ dispatch }, form) {
      const { user } = await firebase.auth.createUserWithEmailAndPassword(form.email, form.password)
      //stworzenie obiekru uzytkownika w usersCollection
      await firebase.usersCollection.doc(user.uid).set({
        name: form.name,
        title: form.title,
        companyEmail: form.companyEmail,
        phoneOne: form.phoneOne,
        phoneTwo: form.phoneTwo,
        companyAddress: form.companyAddress,
      })



      // dispatch('fetchUserProfile',user)
    },
    async fetchUserProfile({ commit }, user) {
      //przypiecie uzytkownika
      const userProfile = await firebase.usersCollection.doc(user.uid).get()

      //ustawienie profilu uzytkownika w stanie 
      commit('setUserProfile', userProfile.data())

      //zmiana drogi na daszbord.
      if (router.currentRoute.path === '/login') {
        router.push('/')
      }
    },
    async logout({ commit }) {
      await firebase.auth.signOut()
      //zmiana stanu uzytkownika mutacja na pusta tablica
      commit('setUserProfile', {})

      //przekierownaie do ponownego logowania
      router.push('/login')
    },
    async createTask({ state, commit }, task) {
      //stworzenie postu w firebase
      await firebase.tasksCollection.add({
        createdOn: new Date(),
        content: task.content,
        title: task.title,
        bike: task.bike,
        frame: task.frame,
        phone: task.phone,
        address: task.address,
        imageUrl: task.imageUrl,
        userId: firebase.auth.currentUser.uid,
        userName: state.userProfile.name,
        userTitle: state.userProfile.title,
        userAddress: state.userProfile.companyAddress,
        userCompanyEmail: state.userProfile.companyEmail,
        userPhoneOne: state.userProfile.phoneOne,
        userPhoneTwo: state.userProfile.phoneTwo,
        taskId: this.state.tasks.length,
        clientComment:"",
        status: 'dodany',
        endDate: '',
        comments: 0
      })
    },
    async addClientComment({ dispatch }, data){
      // console.log(data.clientComment)
      const taskRef = await firebase.tasksCollection.doc(data.task.id).update({
        clientComment: data.clientComment
      }).then(alert("Dodano Uwagi"))

    },
    async updateTaskStatus({ dispatch }, data) {
      const taskRef = await firebase.tasksCollection.doc(data.task.id).update({
        status: data.statusToChange,

      })
      if (data.endDate) {

        const taskRef = await firebase.tasksCollection.doc(data.task.id).update({
          endDate: new Date()

        })
      }
    }
    ,
    async updateProfile({ dispatch }, user) {
      const userId = firebase.auth.currentUser.uid
      //uaktualnienie obiektu uytkownika 
      const userRef = await firebase.usersCollection.doc(userId).update({
        name: user.name,
        title: user.title,
        companyEmail: user.companyEmail,
        companyAddress: user.companyAddress,
        phoneOne: user.phoneOne,
        phoneTwo: user.phoneTwo,
      })

      dispatch('fetchUserProfile', { uid: userId })

      //uaktualnienie wszystkich tasków uytkownika

      const taskDocs = await firebase.tasksCollection.where('userId', '==', userId).get()

      taskDocs.forEach(doc => {
        firebase.tasksCollection.doc(doc.id).update({
          userName: user.name,

        })
      })
      // uaktialnienie wszystkich komentarzy uzystkowniak
      const commentDocs = await firebase.commentsCollection.where('userId', '==', userId).get()
      commentDocs.forEach(doc => {
        firebase.commentsCollection.doc(doc.id).update({
          userName: user.name
        })
      })
    }
  },
})

export default store